import { ServerOption } from '../../server/models/server-option';

export function filterServerOption(servers: ServerOption[], searchText: string | null | undefined): ServerOption[] {
    if (servers.length === 0) {
        return [];
    }
    const term = searchText && searchText.trim();
    if (term) {
        const upper = term.toUpperCase();
        return servers.filter((item) => {
            return item.serverName ? item.serverName.toUpperCase().includes(upper) : false;
        });
    } else {
        return servers || [];
    }
}
